// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"1fa79b7d","59":"ea197b41","62":"bd2ee64b","292":"97e8b8f2","538":"0f3528a0","696":"40cffe73","706":"156daee8","716":"ca1179d5","740":"a4b72a9f","749":"b10c04bb","911":"bf922342","981":"f444fca8"}[chunkId] + ".chunk.js";
};